import { Card, Checkbox, Col, message, Row, Tooltip, Input, Button, Spin } from 'antd';
import { AnimationModal, Tables } from '@/components';
import { AdminRoleTemplateApi, AdminPermissionApi } from 'gmrfid-service-user-api-manager';
import React, { useEffect, useState } from 'react';
import { Wrap } from './style';
import AddForm from './add';

const Combo = () => {
  const [keys, setKeys] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState();
  const [tableKey, setTableKey] = useState();
  const [groupTableTime, setGroupTableTime] = useState();
  const [limitTableTime, setLimitTableTime] = useState();
  const [fields, setFields] = useState({});
  const [comboFields, setComboFields] = useState({});
  const [showDrawer, setShowDrawer] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tableObj, setTableObj] = useState({});
  const [showOnlyChecked, setShowOnlyChecked] = useState(false);

  const delFn = () => {
    AdminRoleTemplateApi.delete({
      form: {
        id: tableObj?.id,
      },
    }).then((res) => {
      if (res && res.status === 200) {
        message.success('操作成功');
        setGroupTableTime(Math.random());
        setTableObj({});
        setVisible(false);
      }
    });
  };

  const columnTemplate = [
    {
      title: '名称',
      align: 'center',
      dataIndex: 'name',
      render: (text, record) => {
        return <span className={record.menuType === 1 ? '' : 'disabled-item'}>{text}</span>;
      },
    },
    {
      title: '资源路径',
      align: 'center',
      dataIndex: 'uri',
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 180,
          },
        };
      },
      render: (text) => (
        <Tooltip title={text}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{text}</div>
        </Tooltip>
      ),
    },
    {
      title: '类型',
      align: 'center',
      dataIndex: 'type',
      render: (text, record) => {
        let str = '';
        let color;
        switch (text) {
          case 'PATH':
            str = '路径';
            color = '#FFA500';
            break;
          case 'MENU':
            str = '菜单';
            color = '#44BB55';
            break;
          case 'BUTTON':
            str = '按钮';
            color = '#00FFFF';
            break;
          case 'APPLICATION':
            str = '应用';
            color = 'rgb(248,155,33)';
            break;
          default:
            break;
        }
        return <span style={{ color }}>{str}</span>;
      },
    },
    {
      title: '权限值',
      align: 'center',
      dataIndex: 'uri',
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 180,
          },
        };
      },
      render: (text) => (
        <Tooltip title={text}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>{text}</div>
        </Tooltip>
      ),
    },
  ];

  const columns = [
    {
      title: '序号',
      dataIndex: 'num',
      align: 'center',
    },
    {
      title: '套餐名称',
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: '使用状态',
      dataIndex: 'useStateEnum',
      align: 'center',
      render: (text, record) => {
        return (
          <span
            style={{
              color: text ? (text === 'IN_USE' ? '#44BB55' : '#666666') : '#666666',
            }}
          >
            {text ? (text === 'IN_USE' ? '使用中' : '未使用') : ''}
          </span>
        );
      },
    },
    {
      title: '操作',
      dataIndex: 'name',
      align: 'center',
      render: (text, record) => (
        <ul className="operation">
          <li
            className="edit"
            onClick={() => {
              setShowDrawer(true);
              setTableObj(record);
            }}
          >
            编辑名称
          </li>
          {record.useStateEnum !== 'IN_USE' && <i />}
          {record.useStateEnum !== 'IN_USE' && (
            <li
              className="del"
              onClick={() => {
                setVisible(true);
                setTableObj(record);
              }}
            >
              删除
            </li>
          )}
        </ul>
      ),
    },
  ];

  // 保存权限
  const saveMenu = () => {
    if (!selectedGroup) {
      return message.info('请先选择套餐');
    }
    AdminRoleTemplateApi.savePermission({
      form: {
        roleTemplateId: selectedGroup.id,
        permissionIds: keys,
      },
    }).then((res) => {
      if (res && res.status === 200) {
        message.success('保存成功');
      }
    });
  };

  /* 监听保存 */
  // useEffect(() => {
  //   if (permissionId) {
  //     saveMenu()
  //   }
  // }, [permissionId])

  const setRowClassName = (record) => {
    return record.id === tableKey ? 'clickRowStyle' : '';
  };

  const rowSelection = {
    checkStrictly: true,
    selectedRowKeys: keys,
    onChange: (selectedRowKeys, selectedRows) => {
      setKeys(selectedRowKeys);
    },
    // onSelect: (record, selected, selectedRows, nativeEvent) => {
    //   console.log('====>', record, selected, selectedRows, nativeEvent)
    //   const arr = selectedRows.map(item => item.id)
    //   // arr.push(record.parentId)
    //   setKeys(arr)
    // }
  };

  const tablesGroupOption = {
    columns,
    pagination: false,
    newPagination: true,
    tableTime: groupTableTime,
    parameterName: 'form',
    rowClassName: setRowClassName,
    queryTableList: AdminRoleTemplateApi.list,
    fields: comboFields,
    rowKey: 'id',
    size: 'medium',
    customSize: 20,
    onRow: (record) => {
      return {
        onClick: (event) => {
          setSelectedGroup(record);
          setTableKey(record.id);
          setFields({ platforms: record.platforms?.join(',') || null });
          AdminRoleTemplateApi.permissionList({
            roleTemplateId: record.id,
          }).then((res) => {
            if (res && res.status === 200) {
              setKeys(res.data.map((item) => item.id));
            }
          });
        },
      };
    },
  };

  const tablesTemplateOption = {
    columns: columnTemplate,
    pagination: false,
    fields,
    parameterName: 'param',
    tableTime: limitTableTime,
    // queryTableList: AdminPermissionApi.list,
    queryTableList: AdminPermissionApi.simpleList,
    tableTree: true,
    rowSelection,
    customSize: 1000,
    newPagination: true,
    filterFn: showOnlyChecked
      ? (data) => {
          // data 是树形结构，需要递归过滤
          const filterTree = (list) =>
            list
              .filter((item) => keys.includes(item.id))
              .map((item) => ({
                ...item,
                children: item.children ? filterTree(item.children) : undefined,
              }));
          return filterTree(data);
        }
      : undefined,
  };

  return (
    <Wrap>
      <Row className="custom-style">
        <Col span={9} style={{ height: '100%' }}>
          <div className="left">
            <Input
              placeholder="请输入套餐名称搜索"
              allowClear
              style={{ width: '70%' }}
              onChange={(e) => { setComboFields({ name: e.target.value }); }}
            />
            <Button className="add" onClick={() => { setShowDrawer(true); }}>
              新建套餐
            </Button>
          </div>
          <div style={{ height: 'calc( 100% - 44px )', overflow: 'auto', padding: '0 10px 0 0' }}>
            <Tables {...tablesGroupOption} />
          </div>
        </Col>
        <Col span={14} offset={1} style={{ height: '100%' }}>
          <div className="left" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Checkbox
              checked={showOnlyChecked}
              onChange={(e) => setShowOnlyChecked(e.target.checked)}
            >
              仅显示已有权限
            </Checkbox>
            <Button className="add" onClick={() => { saveMenu(); }}>
              保存权限
            </Button>
          </div>
          <div style={{ height: 'calc( 100% - 44px )', overflow: 'auto', padding: '0 10px 0 0' }}>
            <Tables {...tablesTemplateOption} />
          </div>
        </Col>
      </Row>
      {showDrawer && (
        <AddForm
          setShowDrawer={setShowDrawer}
          setFields={setFields}
          showDrawer={showDrawer}
          tableObj={tableObj}
          setTableTime={setGroupTableTime}
          setTableObj={setTableObj}
        />
      )}
      {visible && (
        <AnimationModal
          width={480}
          title={'删除'}
          isFooter
          closeCallback={() => {
            setTableObj({});
            setVisible(false);
          }}
          confirmCallback={() => {
            delFn();
          }}
        >
          <h1>{`确认删除【${tableObj?.name}】吗？`}</h1>
        </AnimationModal>
      )}
    </Wrap>
  );
};

export default Combo;
